import './NewsEvents.css';

function NewsEvents(){
    return (
        <div className="home-news-events" id='newsandevents'>
            <div className="container">
                <div className="row">
                    <div className="col-md-12 text-center">
                        <h2 className="heading2">News & Events</h2>
                        <h3 className="heading3">Legal Entity Identifier India Limited</h3>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-3">
                        <div className="fullbox">
                            <span>Dec 30, 2022</span>
                            <p><strong>LEIL Website Scheduled Maintenance</strong>The LEIL website will be undergoing scheduled maintenance on Friday, 30 Dec 2022, from 18:30 - 19:30 IST. So the LEIL website will not be available for this time period.</p>
                            <a href="#">read more <i class="fas fa-chevron-right"></i></a>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="fullbox">
                            <span>Dec 30, 2022</span>
                            <p><strong>LEIL Website Scheduled Maintenance</strong>The LEIL website will be undergoing scheduled maintenance on Friday, 30 Dec 2022, from 18:30 - 19:30 IST. So the LEIL website will not be available for this time period.</p>
                            <a href="#">read more <i class="fas fa-chevron-right"></i></a>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="fullbox">
                            <span>Dec 30, 2022</span>
                            <p><strong>LEIL Website Scheduled Maintenance</strong>The LEIL website will be undergoing scheduled maintenance on Friday, 30 Dec 2022, from 18:30 - 19:30 IST. So the LEIL website will not be available for this time period.</p>
                            <a href="#">read more <i class="fas fa-chevron-right"></i></a>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="fullbox">
                            <span>Dec 30, 2022</span>
                            <p><strong>LEIL Website Scheduled Maintenance</strong>The LEIL website will be undergoing scheduled maintenance on Friday, 30 Dec 2022, from 18:30 - 19:30 IST. So the LEIL website will not be available for this time period.</p>
                            <a href="#">read more <i class="fas fa-chevron-right"></i></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}export default NewsEvents;